import React from 'react'

import PrimaryButton from '@lyrahealth-inc/ui-core/lib/atoms/buttons/primaryButton/PrimaryButton'
import TextButton from '@lyrahealth-inc/ui-core/lib/atoms/buttons/textButton/TextButton'

import styles from './paymentAdditionalInfoContent.module.scss'

const PaymentAdditionalInfoContent: React.FC<PaymentAdditionalInfoContentProps> = ({
  closeModal,
  title,
  description,
  url,
}) => {
  return (
    <div className={styles.container} data-test-id='PaymentAdditionalInfoContent-container'>
      <h3 className={styles['modal-title']} data-test-id='PaymentAdditionalInfoContent-title'>
        {title}
      </h3>
      <p className={styles.description}>{description}</p>
      <PrimaryButton
        data-test-id='PaymentAdditionalInfoContent-learnHow'
        onClick={() => {
          window.open(url)
          closeModal()
        }}
      >
        Learn how
      </PrimaryButton>
      <TextButton
        isPrimary={true}
        customClass={styles['dismiss-button']}
        data-test-id='PaymentAdditionalInfoContent-dismiss'
        text='No thanks'
        onClick={closeModal}
      />
    </div>
  )
}

interface PaymentAdditionalInfoContentProps {
  closeModal: () => void
  title: string
  description: string
  url: string
}

export default PaymentAdditionalInfoContent
